module.exports = __webpack_public_path__ + "img/order_img2.e26d08e6.png";